import { ViewStateTypes } from '@common/enums/viewstate-types';
import { ObjectTypes } from '@src/suite/common/enums/object-types';

import { SingleViewStateRecord } from './single-viewstate-record';

export class SingleItemViewStateRecord extends SingleViewStateRecord {
    public initialize() {
        this.viewStateType = ViewStateTypes.SINGLEITEM;
        super.initialize();
    }

    public get itemGuid(): string {
        return this.getAs<string>('itemGuid');
    }

    public set itemGuid(value: string) {
        this.set('itemGuid', value);
    }

    public get itemType(): ObjectTypes {
        return this.getAs<ObjectTypes>('itemType');
    }

    public set itemType(value: ObjectTypes) {
        this.set('itemType', value);
    }
}
